// extracted by mini-css-extract-plugin
module.exports = {"invoiceDetailsContainer":"InvoiceDetails_invoiceDetailsContainer__T6W8b"};